// extracted by mini-css-extract-plugin
export default {"wrapper":"style--wrapper--376372","title":"style--title--570596"};